'use client';

import { createListCollection } from '@chakra-ui/react';

export const mockCollectionList = createListCollection({
	items: [
		{
			label: 'Mock Full-time',
			value: 'full_time',
		},
		{
			label: 'Mock Part-time',
			value: 'part_time',
		},
	],
});
